export enum FundingSourceType {
  CREDIT_DEBIT = "CREDIT_DEBIT",
  CHEQUE = "CHEQUE",
  CASH = "CASH",
  CUSTOM_FUNDING_SOURCE = "CUSTOM_FUNDING_SOURCE",
}
